// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__25unf","row":"styles_row__3GHA1"};